import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostBinding,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { IAppState } from "../../../store/state/app.state";
import { alertSelector } from "../../../store/selectors/alert.selector";
import { closeAlertAction, okAlertAction } from '../../../store/actions/alert.action';
import { Subscription } from "rxjs";
import { ModuleResolutionKind } from "typescript";
import { CoworkingService } from "../../../services/coworking.service";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../../store/actions/loading.action";
import { CoworkerService } from "../../../services/coworker.service";
import { CompanyService } from "../../../services/company.service";
import { BackofficeService } from "../../../services/backoffice.service";
import { iconsLibrary } from "../../../../theme/constants";
import { BackofficeEditCompanyComponent } from "../../backoffice-edit-company/backoffice-edit-company.component";
import { EButtonType } from '../../../data-types/button.enum';
import { Router } from '@angular/router';
@Component({
  selector: "cowing-core-alert-window",
  templateUrl: "./cowing-alert-window.component.html",
  styleUrls: ["./cowing-alert-window.component.scss"],
})
export class CowingAlertWindowComponent {
  @HostBinding("hidden")
  isHidden: Boolean = true;
  @Input("title") title = "";
  @Input("message") message = "";
  @Input("optionOkText") optionOkText = "";
  @Input("optionCancelText") optionCancelText = "";

  @Output("onCloseEvent") onCloseEvent: EventEmitter<any> = new EventEmitter();
  alert$ = this._store.pipe(select(alertSelector));
  type = "alert";
  subscription: Subscription;
  public EButtonType = EButtonType;
  private spaceId: number = null;
  private bookingId: number = null;
  private employeeId: number = null;
  private deleteCompanyId: number = null;
  public editCompanyId: number = null;
  public editSpaceId: number = null;
  public editCoworkingId: number = null;
  constructor(private _store: Store<IAppState>, private router: Router) {}

  ngOnInit() {
    this.subscription = this.alert$.subscribe((result) => {
      this.type = result.type;
      this.isHidden = !result.show;
      this.title = result.title;
      this.message = result.message;
      this.optionOkText = result.optionOkText;
      this.optionCancelText = result.optionCancelText;
      this.message = result.message;
      console.log(result);
      if (result.spaceId) this.spaceId = result.spaceId;
      if (result.bookingId) this.bookingId = result.bookingId;
      if (result.employeeId) this.employeeId = result.employeeId;
      if (result.deleteCompanyId) this.deleteCompanyId = result.deleteCompanyId;
      if (result.editCompanyId) this.editCompanyId = result.editCompanyId;
      if (result.editSpaceId) this.editSpaceId = result.editSpaceId;
      if (result.editCoworkingId) this.editCoworkingId = result.editCoworkingId;
    });
  }

  public goToLogin() {
    this.router.navigate(['login']);
  }

  public reloadWindow() {
    window.location.reload();
  }

  public pauseSpace() {
    this._store.dispatch(showLoadingAction({}));
    CoworkingService.instance
      .pauseSpace(this.spaceId, 1)
      .then(() => {
        this._store.dispatch(closeLoadingAction({}));
        this.close();
      })
      .catch((err: any) => {
        this._store.dispatch(closeLoadingAction({}));
        console.error("Error pausing space:", err);
      });
  }

  public activateSpace() {
    this._store.dispatch(showLoadingAction({}));
    CoworkingService.instance
      .pauseSpace(this.spaceId, 0)
      .then(() => {
        this._store.dispatch(closeLoadingAction({}));
        this.close();
      })
      .catch((err: any) => {
        this._store.dispatch(closeLoadingAction({}));
        console.error("Error pausing space:", err);
      });
  }

  public confirmBooking() {
    this._store.dispatch(showLoadingAction({}));
    CoworkerService.instance
      .changeBookingStatus(this.bookingId, 4)
      .then(() => {
        this._store.dispatch(closeLoadingAction({}));
        CoworkerService.instance.coworkingStatusModified.next();
        this.close();
      })
      .catch((err: any) => {
        this._store.dispatch(closeLoadingAction({}));
        console.error("Error confirm booking:", err);
      });
  }

  public cancelBooking() {
    this._store.dispatch(showLoadingAction({}));
    CoworkerService.instance
      .changeBookingStatus(this.bookingId, 6)
      .then(() => {
        this._store.dispatch(closeLoadingAction({}));
        CoworkerService.instance.coworkingStatusModified.next();
        this.close();
      })
      .catch((err: any) => {
        this._store.dispatch(closeLoadingAction({}));
        console.error("Error cancel space:", err);
      });
  }

  public deleteEmployee() {
    console.log("IDEMPLOYEE", this.employeeId);
    this._store.dispatch(showLoadingAction({}));
    CoworkerService.instance
      .deleteEmployee(this.employeeId)
      .then(() => {
        this._store.dispatch(closeLoadingAction({}));
        CompanyService.instance.companyModified.next();
        this.close();
      })
      .catch((err: any) => {
        this._store.dispatch(closeLoadingAction({}));
        console.error("Error cancel space:", err);
      });
  }

  public deleteCompany() {
    console.log("delete company", this.deleteCompanyId);
    this._store.dispatch(showLoadingAction({}));
    BackofficeService.instance
      .deleteCompany(this.deleteCompanyId)
      .then(() => {
        this._store.dispatch(closeLoadingAction({}));
        // CompanyService.instance.companyModified.next();
        this.close();
      })
      .catch((err: any) => {
        this._store.dispatch(closeLoadingAction({}));
        console.error("Error deleting company:", err);
      });
  }

  close() {
    this._store.dispatch(closeAlertAction({}));
  }

  onOk() {
    this._store.dispatch(okAlertAction({ action: 'ok' }));
  }

  public get getCloseSvg() {
    return `${iconsLibrary.closeSvg}`;
  }
}
